import { useCallback, useEffect, useState } from 'react';

/**
 * Подсказка горизонтальной прокрутки: широкая таблица/доска обрезалась правым
 * краем, и не было видно, что дальше есть ещё колонки (аудит интерфейса, стр. 123, 125).
 *
 * Возвращает [ref, className]: ref (функция) вешается на прокручиваемый блок —
 * блок может появиться позже, после загрузки; className
 * («scroll-hint scroll-hint--right» и т.п.) — ему же. Затухание рисует index.css.
 */
// withLeft=false — не гасить левый край (там закреплённая колонка, её затухание прячет имена)
export default function useScrollHint({ withLeft = true } = {}) {
  const [node, setNode] = useState(null);
  const [edges, setEdges] = useState({ left: false, right: false });

  const update = useCallback(() => {
    const el = node;
    if (!el) return;
    const left = el.scrollLeft > 2;
    const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    setEdges(prev => (prev.left === left && prev.right === right ? prev : { left, right }));
  }, [node]);

  useEffect(() => {
    const el = node;
    if (!el) return undefined;
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      el.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [node, update]);

  // Содержимое могло смениться (загрузились данные) — пересчитываем края после
  // каждой отрисовки; состояние меняется, только если края правда сдвинулись.
  useEffect(() => { update(); });

  const cls = ['scroll-hint', withLeft && edges.left && 'scroll-hint--left', edges.right && 'scroll-hint--right']
    .filter(Boolean).join(' ');
  return [setNode, cls];
}
